<template>
  <div id="tamiCreditCardFormApp">
    <CardForm
      :form-data="formData"
      @input-card-number="updateCardNumber"
      @input-card-name="updateCardName"
      @input-card-month="updateCardMonth"
      @input-card-year="updateCardYear"
      @input-card-cvv="updateCardCvv"
    />
  </div>
</template>

<script>
import CardForm from '@/components/CardForm'

export default {
  name: 'tamiCreditCardFormApp',
  components: {
    CardForm
  },
  data () {
    return {
      formData: {
        cardName: (typeof window['tamiPaymentForm'] === 'object' && typeof window['tamiPaymentForm'].cardHolder === 'string' ? window['tamiPaymentForm'].cardHolder : ''),
        cardNumber: (typeof window['tamiPaymentForm'] === 'object' && typeof window['tamiPaymentForm'].cardNumber === 'string' ? window['tamiPaymentForm'].cardNumber : ''),
        cardMonth: (typeof window['tamiPaymentForm'] === 'object' && (typeof window['tamiPaymentForm'].cardMonth === 'string' || typeof window['tamiPaymentForm'].cardMonth === 'number') ? window['tamiPaymentForm'].cardMonth : ''),
        cardYear: (typeof window['tamiPaymentForm'] === 'object' && (typeof window['tamiPaymentForm'].cardMonth === 'string' || typeof window['tamiPaymentForm'].cardYear === 'number') ? window['tamiPaymentForm'].cardYear : ''),
        cardCvv: (typeof window['tamiPaymentForm'] === 'object' && (typeof window['tamiPaymentForm'].cardCvv === 'string' || typeof window['tamiPaymentForm'].cardCvv === 'number') ? window['tamiPaymentForm'].cardCvv : ''),
        installment: (typeof window['tamiPaymentForm'] === 'object' && (typeof window['tamiPaymentForm'].installment === 'string' || typeof window['tamiPaymentForm'].installment === 'number') ? window['tamiPaymentForm'].installment : '')
      },
      popupShowStatus: false
    }
  },
  methods: {
    updateCardNumber (val) {
    },
    updateCardName (val) {
    },
    updateCardMonth (val) {
    },
    updateCardYear (val) {
    },
    updateCardCvv (val) {
    }
  },
  mounted () {
    this.$i18n.locale = 'default'
  }
}
</script>

<style lang="scss">
@import '../src/assets/style.scss';
</style>
